/**************************************************
 * Nombre:       Formulario_Datos_Entrega
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AccountCircleOutlined, BadgeOutlined, MailOutline, WhatsApp} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";


const Formulario_Datos_Entrega = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'}
                                  dato={'nombres'} {...props} requerido={'Campo requerido'}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'}
                                  dato={'apellidos'} {...props} requerido={'Campo requerido'}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={WhatsApp} nombre={'WhatsApp'} ejemplo={'3001122333'} type={'phone'}
                                  dato={'celular'} {...props} requerido={'El celular es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} type={'number'}
                                  dato={'cc'} {...props} requerido={'El celular es requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo Electrónico'} type={'mail'}
                                  dato={'correo'} {...props} requerido={'El Correo es requerido'}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Datos_Entrega